
import React, { useEffect, useState, useMemo } from "react";

const Logisticsorderdetails = () => {
    const [activeTab] = useState("Overview");
    const [offersData, setOffersData] = useState([]);
    const [filteredOffersData, setFilteredOffersData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState("");

    // NEW: Filter states like Userdetails file
    const [searchType, setSearchType] = useState("id"); // Changed from "offerId" to "id"
    const [searchQuery, setSearchQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("");

    // Search options for dropdown - updated field names
    const searchOptions = [
        { value: "id", label: "Offer ID" }, // Changed from "offerId" to "id"
        { value: "orderId", label: "Order ID" }, // Add this line
        { value: "partnerId", label: "Partner ID" },
        { value: "userName", label: "User Name" },
        { value: "userPhone", label: "User Phone" },
        { value: "vendorRestaurentname", label: "Vendor Restaurant" }
    ];

    // Status options for dropdown
    const statusOptions = [
        { value: "", label: "All Status" },
        { value: "DELIVERED", label: "Delivered" },
        { value: "REJECTED", label: "Rejected" },
        // { value: "ACCEPTED", label: "Accepted" },
        // { value: "PENDING", label: "Pending" }
    ];

    // Fetch offers data
    useEffect(() => {
        const fetchOffersData = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    console.error("No auth token found");
                    setOffersData([]);
                    return;
                }

                const response = await fetch(
                    "https://backend.maamaas.com/delivery/api/admin/get/all/offers",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const offersData = await response.json();
                console.log("📊 Offers data:", offersData);

                // Debug: Log first item to see field names
                if (offersData.length > 0) {
                    console.log("📋 First offer item fields:", Object.keys(offersData[0]));
                    console.log("📋 First offer item values:", offersData[0]);
                }

                setOffersData(Array.isArray(offersData) ? offersData : []);
            } catch (error) {
                console.error("Error fetching offers data:", error);
                setOffersData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchOffersData();
    }, []);

    // NEW: Get placeholder text based on search type
    const getPlaceholderText = () => {
        switch (searchType) {
            case "id": return "Search Offer ID"; // Updated
            case "orderId": return "Search Order ID"; // Add this line
            case "partnerId": return "Search Partner ID";
            case "userName": return "Search User Name";
            case "userPhone": return "Search User Phone";
            case "vendorRestaurentname": return "Search Vendor Restaurant";
            default: return "Search...";
        }
    };

    // NEW: Clear all filters
    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedDate("");
        setStatusFilter("");
    };

    // NEW: Search filtered data - FIXED search logic
    const searchFilteredData = useMemo(() => {
        if (!offersData.length) return [];

        let data = offersData;

        // Date filter
        if (selectedDate) {
            data = data.filter((item) => {
                if (!item.createdAt) return false;

                const itemDate = new Date(item.createdAt);
                const selected = new Date(selectedDate);

                return itemDate.getDate() === selected.getDate() &&
                    itemDate.getMonth() === selected.getMonth() &&
                    itemDate.getFullYear() === selected.getFullYear();
            });
        }

        // Status filter
        if (statusFilter) {
            data = data.filter((item) => {
                if (!item.status) return false;
                return item.status === statusFilter;
            });
        }

        // Search filter - FIXED: Handle different field names properly
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            data = data.filter((item) => {
                let fieldValue;

                // Map search type to actual field name in data
                switch (searchType) {
                    case "id":
                        fieldValue = item.id || item.offerId; // Try both id and offerId
                        break;
                    case "orderId": // Add this case
                        fieldValue = item.orderId;
                        break;
                    case "partnerId":
                        fieldValue = item.partnerId;
                        break;
                    case "userName":
                        fieldValue = item.userName;
                        break;
                    case "userPhone":
                        fieldValue = item.userPhone;
                        break;
                    case "vendorRestaurentname":
                        fieldValue = item.vendorRestaurentname;
                        break;
                    default:
                        fieldValue = item[searchType];
                }

                if (!fieldValue) return false;

                // Convert to string for searching
                const stringValue = String(fieldValue).toLowerCase();

                // Special handling for phone number search
                if (searchType === "userPhone") {
                    const cleanUserPhone = stringValue.replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return stringValue.includes(query) || cleanUserPhone.includes(cleanQuery);
                }

                // For other fields
                return stringValue.includes(query);
            });
        }

        console.log("🔍 Filtered data count:", data.length);
        return data;
    }, [offersData, selectedDate, statusFilter, searchQuery, searchType]);

    // Apply filters to offers data
    useEffect(() => {
        setFilteredOffersData(searchFilteredData);
    }, [searchFilteredData]);

    // Export CSV function
    const handleExport = () => {
        const exportData = searchFilteredData.length > 0 ? searchFilteredData : offersData;

        if (exportData.length === 0) {
            alert("No data available for export.");
            return;
        }

        const headersCSV = [
            "S.No", "Offer ID", "Order ID", "Partner ID", "Status", "User Name", "User Phone",
            "Vendor Restaurant", "Items", "Earning", "Vehicle Status", "Created At"
        ];

        const csvRows = exportData.map((item, index) => [
            index + 1,
            item.id || "",
            item.orderId || "", // Add this line
            item.partnerId || "",
            item.status || "",
            item.userName || "",
            item.userPhone || "",
            item.vendorRestaurentname || "",
            item.items || "",
            item.earning !== undefined ? `₹${item.earning}` : "",
            item.vehicleStatus || "",
            item.createdAt ? new Date(item.createdAt).toLocaleString() : ""
        ]);

        const csvString = [headersCSV.join(","), ...csvRows.map(r => r.join(","))].join("\r\n");

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `logistics_offers_${selectedDate || "all"}.csv`;
        link.click();
        URL.revokeObjectURL(url);
    };

    const customPurpleBg = {
        backgroundColor: "rgb(230 109 51)",
        color: "#fff",
        border: "none",
    };

    const headerStyle = {
        backgroundColor: "rgb(230 109 51)",
        color: "#fff",
        textAlign: "center",
        padding: "8px",
        border: "1px solid #ddd",
        position: 'sticky',
        top: 0,
        zIndex: 100
    };

    const cellStyle = {
        textAlign: "center",
        padding: "8px",
        border: "1px solid #ddd",
    };

    const tabContent = {
        Overview: (
            <div style={{ width: "100%", marginTop: "-35px", marginBottom: "50px", padding: "20px" }}>
                {/* NEW: FILTERS CONTAINER */}
                <div
                    className="row g-2 mb-3 align-items-center"
                    style={{ padding: "15px", borderRadius: "6px" }}
                >
                    {/* Search Type Dropdown and Search Input */}
                    <div className="col-md-auto col-12">
                        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                            {/* Search Type Dropdown */}
                            <div style={{ minWidth: '150px' }}>
                                <select
                                    className="form-select"
                                    value={searchType}
                                    onChange={(e) => setSearchType(e.target.value)}
                                    style={{ height: "40px" }}
                                >
                                    {searchOptions.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Search Input */}
                            <div style={{ minWidth: '200px' }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={getPlaceholderText()}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    style={{ height: "40px" }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Date Filter */}
                    <div className="col-md-auto col-12">
                        <input
                            type="date"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            style={{
                                backgroundColor: "rgb(230 109 51)",
                                color: "#fff",
                                border: "none",
                                height: "40px",
                                borderRadius: "4px",
                                padding: "0 10px",
                                minWidth: "150px"
                            }}
                        />
                    </div>

                    {/* Status Filter */}
                    <div className="col-md-auto col-12">
                        <select
                            className="form-select"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            style={{ maxWidth: '150px', height: "40px" }}
                        >
                            {statusOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Clear Filters Button */}
                    <div className="col-md-auto col-12">
                        <button
                            className="btn"
                            onClick={clearAllFilters}
                            style={{
                                backgroundColor: '#6c757d',
                                color: '#fff',
                                height: "40px",
                                padding: "0 15px"
                            }}
                        >
                            Clear Filters
                        </button>
                    </div>

                    {/* Export Button */}
                    <div className="col-md col-12">
                        <div className="d-flex justify-content-start justify-content-md-end">
                            <button
                                className="btn"
                                onClick={handleExport}
                                style={{
                                    backgroundColor: 'rgb(230 109 51)',
                                    color: '#fff',
                                    height: "40px",
                                    padding: "0 20px"
                                }}
                            >
                                Export
                            </button>
                        </div>
                    </div>
                </div>

                {/* Offers Table with Scroll */}
                <div
                    className="table-responsive"
                    style={{
                        maxHeight: 'calc(100vh - 250px)',
                        overflowY: 'auto',
                        border: '1px solid #dee2e6',
                        borderRadius: '6px'
                    }}
                >
                    <table
                        className="table table-bordered table-striped align-middle"
                        style={{ marginBottom: 0 }}
                    >
                        <thead style={{ position: 'sticky', top: 0, zIndex: 100 }}>
                            <tr>
                                <th style={headerStyle}>S.No</th>
                                <th style={headerStyle}>Offer ID</th>
                                <th style={headerStyle}>Order ID</th> {/* Add this line */}
                                <th style={headerStyle}>Partner ID</th>
                                <th style={headerStyle}>Status</th>
                                <th style={headerStyle}>User Name</th>
                                <th style={headerStyle}>User Phone</th>
                                <th style={headerStyle}>Vendor Restaurant</th>
                                <th style={headerStyle}>Items</th>
                                <th style={headerStyle}>Earning</th>
                                <th style={headerStyle}>Vehicle Status</th>
                                <th style={headerStyle}>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center', fontStyle: 'italic', padding: '20px' }}>
                                        Loading offers data...
                                    </td>
                                </tr>
                            ) : searchFilteredData.length > 0 ? (
                                searchFilteredData.map((item, index) => {
                                    let createdAtDate = "N/A";
                                    let createdAtTime = "N/A";

                                    if (item.createdAt) {
                                        const dateObj = new Date(item.createdAt);
                                        // Format as date/month/year
                                        createdAtDate = `${String(dateObj.getDate()).padStart(2, "0")}/${String(dateObj.getMonth() + 1).padStart(2, "0")}/${dateObj.getFullYear()}`;
                                        // Format time as HH:MM AM/PM
                                        createdAtTime = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                                    }

                                    return (
                                        <tr key={item.id || index}>
                                            <td style={cellStyle}>{index + 1}</td>
                                            <td style={cellStyle}>{item.id || "N/A"}</td>
                                            <td style={cellStyle}>{item.orderId || "N/A"}</td> {/* Add this line */}
                                            <td style={cellStyle}>{item.partnerId || "N/A"}</td>
                                            <td style={cellStyle}>
                                                <span style={{
                                                    backgroundColor: item.status === 'DELIVERED' ? '#28a745' :
                                                        item.status === 'REJECTED' ? '#dc3545' :
                                                            item.status === 'ACCEPTED' ? '#17a2b8' :
                                                                '#ffc107',
                                                    color: item.status === 'DELIVERED' || item.status === 'REJECTED' || item.status === 'ACCEPTED' ? '#fff' : '#212529',
                                                    padding: '3px 8px',
                                                    borderRadius: '12px',
                                                    fontSize: '0.85em',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {item.status || "N/A"}
                                                </span>
                                            </td>
                                            <td style={cellStyle}>{item.userName || "N/A"}</td>
                                            <td style={cellStyle}>{item.userPhone || "N/A"}</td>
                                            <td style={cellStyle}>{item.vendorRestaurentname || "N/A"}</td>
                                            <td style={cellStyle}>{item.items || "N/A"}</td>
                                            <td style={cellStyle}>
                                                {item.earning !== undefined
                                                    ? `₹${item.earning}`
                                                    : "N/A"}
                                            </td>
                                            <td style={cellStyle}>{item.vehicleStatus || "N/A"}</td>
                                            <td style={cellStyle}>
                                                <div>{createdAtDate}</div>
                                                <div style={{ fontSize: '0.85em', color: '#666' }}>{createdAtTime}</div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center', fontStyle: 'italic', padding: '20px' }}>
                                        {offersData.length === 0
                                            ? "No offers data available."
                                            : (searchQuery.trim() || selectedDate || statusFilter)
                                                ? "No offers found with the specified filters."
                                                : "No offers data available."}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        ),
    };

    return (
        <div style={{ padding: "20px", marginBottom: "50px" }}>
            <div
                style={{
                    overflowY: "auto",
                    height: "calc(100vh - 100px)",
                }}
            >
                <div>{tabContent[activeTab]}</div>
            </div>
        </div>
    );
};

export default Logisticsorderdetails;